import IFormService from "./IFormService";
import FormData from "../../dto/Form/FormData";
import FormSection from "../../dto/Form/FormSection";
import FormField from "../../dto/Form/FormField";
import FormFieldType from "../../dto/Form/FormFieldType";
import FormSaveData from "../../dto/Form/FormSaveData";
import MultiSelectConfig from "../../dto/Form/MultiSelectConfig";
import MultiSelectConfigOptionGroup from "../../dto/Form/MultiSelectConfigOptionGroup";
import MultiSelectConfigOption from "../../dto/Form/MultiSelectConfigOption";
import CaptchaData from "../../dto/Captcha/CaptchaData";
import FormFieldRule from "../../dto/Form/FormFieldRule";
import TableSelectConfig from "../../dto/Form/TableSelectConfig";
import TableSelectColumnConfig from "../../dto/Form/TableSelectColumnConfig";
import TableSelectRow from "../../dto/Form/TableSelectRow";
import TableSelectColumnType from "../../dto/Form/TableSelectColumnType";

export default class MockFormService implements IFormService {
    public async getFormData_Table(id: string, token: string): Promise<FormData> {
        let formData = new FormData();
        formData.title = "LongList auswählen";

        let section1 = new FormSection();
        section1.id = "2d26e199-21b1-4317-a4fc-fc0419bae3c3";
        section1.title = "LongList";

        let tableSelectConfig = new TableSelectConfig();
        let nameColumn = new TableSelectColumnConfig();
        nameColumn.internalName = "name";
        nameColumn.label = "Name";
        tableSelectConfig.columns.push(nameColumn);
        let urlColumn = new TableSelectColumnConfig();
        urlColumn.internalName = "url";
        urlColumn.columnType = TableSelectColumnType.link;
        urlColumn.label = "URL";
        tableSelectConfig.columns.push(urlColumn);
        for(let curRow = 0; curRow < 100; ++curRow) {
            let row = new TableSelectRow();
            row.id = curRow.toString();
            row.values = {};
            row.values["name"] = "Test" + curRow;
            row.values["url"] = "https://google.com";
            tableSelectConfig.rows.push(row);
        }
        section1.fields = [
            this.createFormField("84468fe7-8053-4f9c-afca-2785e758d43a", "", FormFieldType.TableSelect, false, tableSelectConfig, [ ]),
        ]
        formData.sections.push(section1);

        return formData;
    }

    public async getFormData(id: string, token: string): Promise<FormData> {
        let formData = new FormData();
        formData.title = "6 Fragen";

        let section1 = new FormSection();
        section1.id = "5f6d251f-b667-4192-84bc-0a3d72371b82";
        section1.title = "Ihr Unternehmen";
        section1.fields = [
            this.createFormField("ea7ad854-ef51-4d69-a21e-ee29c3ee7a27", "Name", FormFieldType.Text, true, null, null),
        ]
     //   formData.sections.push(section1);
        
        let section2 = new FormSection();
        section2.id = "2d26e199-21b1-4317-a4fc-fc0419bae3c3";
        section2.title = "Branchen";

        let branchConfig = new MultiSelectConfig();
        let electroConfig = new MultiSelectConfigOptionGroup();
        electroConfig.title = "Elektro";
        let electro1 = new MultiSelectConfigOption();
        electro1.key = "1";
        electro1.label = "Elektronoik";
        electroConfig.options.push(electro1);
        let electro2 = new MultiSelectConfigOption();
        electro2.key = "2";
        electro2.label = "Analytische und wissenschaftliche Instrumente";
        electroConfig.options.push(electro2);
        branchConfig.options.push(electroConfig);

        let industryConfig = new MultiSelectConfigOptionGroup();
        industryConfig.title = "Industrieautomation";
        let industry1 = new MultiSelectConfigOption();
        industry1.key = "4";
        industry1.label = "Industrieautomation";
        industryConfig.options.push(industry1);
        let industry2 = new MultiSelectConfigOption();
        industry2.key = "5";
        industry2.label = "Industrielle Mess- und Sensortechnik";
        industryConfig.options.push(industry2);
        branchConfig.options.push(industryConfig);

        for(let curExpand = 0; curExpand < 100; ++curExpand) {
            let expandoOption = new MultiSelectConfigOption();
            expandoOption.key = "expand_" + curExpand.toString();
            expandoOption.label = curExpand.toString();
            industryConfig.options.push(expandoOption);
        }

        let formRule = new FormFieldRule();
        formRule.fieldName = "ea7ad854-ef51-4d69-a21e-ee29c3ee7a27";
        formRule.containsValue = "Test";
        formRule.setToRequiredIfTrue = true;

        let hideFormRule = new FormFieldRule();
        hideFormRule.fieldName = "ea7ad854-ef51-4d69-a21e-ee29c3ee7a27";
        hideFormRule.containsValue = "Test";
        hideFormRule.showIfTrue = true;

        let hideFormRule2 = new FormFieldRule();
        hideFormRule2.fieldName = "ea7ad854-ef51-4d69-a21e-ee29c3ee7a27";
        hideFormRule2.notContainsValue = "Test";
        hideFormRule2.showIfTrue = true;

        section2.fields = [
            this.createFormField("2afd3910-c0ed-4a75-8e6c-e8d29e79ce8a", "Beschreibung", FormFieldType.InfoText, true, {
                text: "Es wurde Test eingegeben."
            }, [ hideFormRule ]),
            this.createFormField("5ba8d40c-4397-405b-a6e2-b699e6200e62", "Beschreibung", FormFieldType.InfoText, true, {
                text: "Es wurde NICHT Test eingegeben."
            }, [ hideFormRule2 ]),
            this.createFormField("84468fe7-8053-4f9c-afca-2785e758d43a", "Branche", FormFieldType.MultiSelect, false, branchConfig, [ formRule ]),
        ]
        formData.sections.push(section2);

        let section3 = new FormSection();
        section3.id = "c38f29cd-3c06-4c84-bd57-6f77e191ee3f";
        section3.title = "Unternehmensdaten";
        section3.fields = [
            this.createFormField("ea7ad854-ef51-4d69-a21e-ee29c3ee7a27", "EBIT", FormFieldType.Number, true, null, null),
        ]
        formData.sections.push(section3);

        return formData;
    }
    
    private createFormField(id: string, label: string, type: FormFieldType, required: boolean, config: any, rules: FormFieldRule[] | null): FormField {
        let formField = new FormField();
        formField.id = id;
        formField.title = label;
        formField.type = type;
        formField.required = required;
        formField.config = config;
        formField.rules = rules;
        return formField;
    }

    public saveFormData(id: string, token: string, formData: FormSaveData, captchaData: CaptchaData, captchaValue: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            console.log(formData);
            setTimeout(() => {
                resolve();
            }, 1000);
        });
    }
}